// HelpfulTips.styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Cards, Colors, FontWeight } from '../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    ...Cards.CardShadow1,
    padding: 20,
    height: '100%',
  },
  title: {
    fontSize: 15,
    color: `${Colors.Blue} !important`,
    fontWeight: FontWeight.Bold,
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    backgroundColor: `${Colors.Orange1} !important`,
    marginRight: 11,
    width: 44,
    height: 44,
  },
  avatarSmall: {
    backgroundColor: `${Colors.Orange1} !important`,
    display: 'inline-flex !important',
    verticalAlign: 'sub !important',
    width: 20,
    height: 20,
    margin: '0 4px',
    '& > svg': {
      transform: 'scale(0.6)',
    },
  },
  paragraph: {
    borderBottom: `1px solid ${Colors.Gray5}`,
    fontSize: '13px !important',
    lineHeight: '26px !important',
    margin: '0 -20px !important',
    padding: '15px 20px !important',
    '&:last-child': {
      borderBottom: 0,
      paddingBottom: 0,
    },
  },
}));

export default useStyles;
